import React, {useCallback, useState, useEffect, useMemo, Fragment} from "react"
import {useSelector, useDispatch} from "react-redux"
import {Transition} from "react-transition-group"
import {useDropzone} from "react-dropzone"

import LeftWorkHeader from "../LeftWorkHeader/LeftWorkHeader"

import "./leftworkupload.scss"

import {setHourglassState} from "../../../redux/actions/hourglassAction"

/**
 * Image download component
 * @component
 * @param  {object} props
 * @param  {boolean} props.active - component state
 *
 * @example
 * const active = false
 *
 * return (
 *  <LeftWorkUpload
 *    active={active}
 *  />
 * )
 */

const LeftWorkUpload = ({active}) => {
  const dispatch = useDispatch()
  const makFabric = useSelector(state => state.makFabric)
  const [imgs, setImgs] = useState([])
  const [flag, setFlag] = useState(false)

  const onDrop = useCallback(
    acceptedFiles => {
      const reader = new FileReader()
      dispatch(setHourglassState(true))
      reader.readAsDataURL(acceptedFiles[0])
      reader.onload = e => {
        if (acceptedFiles[0].type !== "application/pdf") {
          makFabric.addImage(e.target.result)
          dispatch(setHourglassState(false))
        } else {
          window.PDFJS.getDocument(e.target.result).then(function (pdf) {
            let numberOfPage = 1

            pdf.getPage(numberOfPage).then(function (page) {
              let viewport = page.getViewport(1.0)
              let canvasEl = document.createElement("canvas")
              let borderWidth = 2
              canvasEl.height = viewport.height + borderWidth
              canvasEl.width = viewport.width + borderWidth
              canvasEl.getContext("2d").translate(-borderWidth, -borderWidth)

              page
                .render({
                  canvasContext: canvasEl.getContext("2d"),
                  viewport: viewport,
                })
                .then(function () {
                  let bg = canvasEl.toDataURL("image/png", 0.5)
                  makFabric.addImage(bg)
                  dispatch(setHourglassState(false))
                })
            })
          })
        }

        setTimeout(() => setFlag(true), 100)
      }
    },
    [makFabric, dispatch],
  )

  const reuseImg = useCallback(({target}) => makFabric.addImage(target.src), [
    makFabric,
  ])

  useEffect(() => {
    if (imgs && makFabric && flag) {
      setImgs(makFabric.getAllUniqImages())
      setFlag(false)
    }
  }, [flag, imgs, makFabric])

  const renderImgs = useMemo(
    () =>
      imgs.length
        ? imgs.map(item => (
            <div key={item}>
              <img src={item} alt="reuse" onClick={reuseImg} />
            </div>
          ))
        : null,
    [imgs, reuseImg],
  )

  // console.log(imgs, makFabric && makFabric.getAllUniqImages(), flag)

  const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop})

  return (
    <Transition
      in={active}
      timeout={200}
      unmountOnExit={true}
      mountOnEnter={true}
    >
      {state => (
        <div
          className="leftWorkUploadContainer"
          style={{
            ...transitionStyles[state],
          }}
        >
          <LeftWorkHeader title="Upload image" />
          <div className="leftWorkUploadContent">
            <div className="leftWorkUploadUpload">
              <div className="leftWorkUploadTitle">Upload Images</div>
              <div className="leftWorkUploadUploadArea" {...getRootProps()}>
                <input
                  {...getInputProps()}
                  accept="image/jpg, image/jpeg, image/png, image/svg+xml, application/pdf"
                />
                {isDragActive ? (
                  <p>Drop the files here ...</p>
                ) : (
                  <Fragment>
                    <div className="leftWorkUploadUploadArea_text">Drag & Drop</div>
                    <div className="leftWorkUploadUploadArea_text">or</div>
                    <div
                      className={"leftWorkUploadUploadArea_text " + "leftWorkUploadUploadArea_text_bl"}
                    >
                      <img
                        src="/assets/img/icons/upload_icn.svg"
                        alt="upload"
                      />
                      Upload
                    </div>
                  </Fragment>
                )}
              </div>
            </div>
            <div className="leftWorkUploadReuse">
              <div className="leftWorkUploadTitle">
                Select from images already uploaded
              </div>
              <div className="leftWorkUploadImgsContainer">{renderImgs}</div>
            </div>
          </div>
        </div>
      )}
    </Transition>
  )
}

export default LeftWorkUpload

const transitionStyles = {
  entering: {opacity: 0},
  entered: {opacity: 1, position: "relative"},
  exiting: {opacity: 0},
  exited: {opacity: 0},
}
